// listy płatności

import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';

import { useGetDocumentsSummaryVmp } from 'api';
import { ClockIcon, AlertIcon } from 'assets/icons';

import styles from 'theme/pages/Dashboard/Dashboard.module.scss';

const Payments = () => {
  // pobieranie podsumowania listy dokumentów
  const { data: settlements } = useGetDocumentsSummaryVmp();

  return (
    <div className={classnames(styles.payments, 'StylePath-Pages-Dashboard-Components-Payments')}>
      <div className={styles.tile}>
        <div className={styles.title}>
          <ClockIcon />
          <Trans>Nadchodzące płatności</Trans>
        </div>
        <div className={styles.row}>
          <span>
            <Trans>Ilość faktur</Trans>
          </span>
          <span>
            <Trans>Suma</Trans>
          </span>
        </div>
        <div className={styles.row}>
          <div>{settlements?.upcoming_payments.count}</div>
          <div className={styles.price}>
            {settlements?.upcoming_payments.amount_formatted.replace('.', ',')}{' '}
            {settlements?.upcoming_payments.currency}{' '}
            <span className={styles.brutto}>
              <Trans>brutto</Trans>
            </span>
          </div>
        </div>
      </div>
      <div
        className={classnames(styles.tile, {
          [styles.noOverdue]: !settlements?.payment_after_deadline.count
        })}>
        {settlements?.payment_after_deadline.count ? (
          <>
            <div className={styles.title}>
              <AlertIcon />
              <Trans>Po terminie</Trans>
            </div>
            <div className={styles.row}>
              <span>
                <Trans>Ilość faktur</Trans>
              </span>
              <span>
                <Trans>Suma</Trans>
              </span>
            </div>
            <div className={styles.row}>
              <div>{settlements?.payment_after_deadline.count}</div>
              <div className={styles.price}>
                {settlements?.payment_after_deadline.amount_formatted.replace('.', ',')}{' '}
                {settlements?.payment_after_deadline.currency}{' '}
                <span className={styles.brutto}>
                  <Trans>brutto</Trans>
                </span>
              </div>
            </div>
          </>
        ) : (
          <Trans>Brak przeterminowanych faktur.</Trans>
        )}
      </div>
    </div>
  );
};

export default Payments;
